module.exports = require("@tiptap/vue-2");